import {
  newRelicTransport,
  nessieTransport,
  consoleTransport,
} from './transports';
import { devServerTransport } from './transports/devServer';

const isDev = process.env.NODE_ENV === 'development';

export const getServerTransports = ({ externalLogger, newrelic }) => {
  const transports = [];
  if (newrelic) {
    transports.push(newRelicTransport(newrelic));
  }

  if (isDev) {
    transports.push(devServerTransport);
  } else if (externalLogger) {
    transports.push(nessieTransport(externalLogger));
  }
  return transports;
};

export const getClientTransports = ({ isConsoleLoggingEnabled }) => {
  const transports = [];

  if (window.newrelic) {
    transports.push(newRelicTransport(window.newrelic));
  }

  if (isConsoleLoggingEnabled) {
    transports.push(consoleTransport);
  }
  return transports;
};
